import { request } from "../network/request";
const db = "dn0";

/**项目列表 */
export function getProjectList(params) {
    return request({
        url: "pmp/xmArchives/querybmxms",
        method: "get",
        params,
        db
    });
}

/**基本信息 */
export function getProjectBaseInfo(params) {
    return request({
        url: "pmp/xmArchives/xmBasicData",
        method: "get",
        params,
        db
    });
}

/**
 * 年度规划
 * @param {*} params 
 * @returns 
 */
export function getNdProgram(params) {
    return request({
        url: "pmp/xmArchives/getNdProgram",
        method: "get",
        params,
        db
    });
}

/**
 * 当月任务
 * @param {*} params 
 * @returns 
 */
export function getDyTask(params) {
    return request({
        url: "pmp/xmArchives/getDyTask",
        method: "get",
        params,
        db
    });
}

/**
 * 高管拜访
 * @param {*} params 
 * @returns 
 */
export function getXmggbflist(params) {
    return request({
        url: "pmp/xmArchives/getXmggbflist",
        method: "post",
        params,
        db
    });
}

/**
 * 项目团队
 * @param {*} params 
 * @returns 
 */
export function getXmtd(params) {
    return request({
        url: "pmp/xmArchives/getXmtd",
        method: "post",
        params,
        db
    });
}
/**
 * 记工作条线汇总
 * @param {*} params 
 * @returns 
 */
export function getXmgzlList(params) {
    return request({
        url: "pmp/xmArchives/getXmgzlList",
        method: "post",
        params,
        db
    });
}
// 本周投入
export function getXmtrlist(params) {
    return request({
        url: "pmp/xmArchives/getXmtrlist",
        method: "post",
        params,
        db
    });
}

//本周进展
export function getXmjzlist(params) {
    return request({
        url: "pmp/xmArchives/getXmjzlist",
        method: "post",
        params,
        db
    });
}
//下周计划
export function getXzjzlist(params) {
    return request({
        url: "pmp/xmzb/selectTeamWorks",
        method: "get",
        params,
        db
    });
}
//记工作条线明细
export function getProjectWorkLoad(params) {
    return request({
        url: "pmp/xmArchives/getProjectWorkLoad",
        method: "post",
        params,
        db
    });
}


// 财务状况
export function getCwzk(params) {
    return request({
        url: "pmp/xmArchives/getCwzk",
        method: "post",
        params,
        db
    });
}
//项目回款
export function getXmHkList(params) {
    return request({
        url: "pmp/xmArchives/getXmHkList",
        method: "post",
        params,
        db
    });
}
//已开票未收款
export function getXmWsList(params) {
    return request({
        url: "pmp/xmArchives/getXmWsList",
        method: "post",
        params,
        db
    });
}
//工作量成本
export function getGzlcbList(params) {
    return request({
        url: "pmp/xmArchives/getGzlcbList",
        method: "post",
        params,
        db
    });
}
// 工作量成本导出
export function detailExport(params) {
    return request({
        url: "pmp/cbhs/detailExport",
        method: "post",
        params,
    });
}
//模拟利润
export function getMnlrList(params) {
    return request({
        url: "pmp/xmArchives/getMnlrList",
        method: "post",
        params,
        db
    });
}

//项目报销

export function getXmbxList(params) {
    return request({
        url: "pmp/xmArchives/getXmbxList",
        method: "post",
        params,
        db
    });
}

export function toWm(params) {
    return request({
        url: "api/toWm",
        method: "get",
        params,
        db
    });
}